// Le calendrier culturel du dossier (V4StudioCalendar).
export default {
  titre: 'Calendrier culturel & opportunités',
  erreur: {
    illisible: 'Calendrier illisible',
    generation: 'Génération impossible',
    selection: 'Sélection non sauvegardée',
    deMarque: '{marque} : {message}',
  },
  reco: {
    priorite: 'PRIORITÉ',
    considerer: 'À CONSIDÉRER',
    radar: 'RADAR',
  },
  audience: {
    coeur: 'CŒUR',
    adjacent: 'ADJACENT',
    hors_cible: 'HORS CIBLE',
  },
  date: {
    confirme: 'Confirmé',
    fenetre: 'Fenêtre',
    tbc: 'TBC',
  },
  // Les formats que le moteur écrit ; un format inconnu passe par la traduction.
  format: {
    shorts: 'Shorts flow',
    post: 'Post',
    visuel: 'Visuel',
    sondage: 'Sondage',
    veille: 'Veille',
  },
  case: {
    deMarque: '{marque} : {texte}',
    evenement: '{nom} - {etat}',
  },
  milestone: 'milestone interne',
  milestoneTitre: 'Milestone interne',
  sousTitre: {
    genere: 'généré le {date}',
    marques: '{n} marques',
  },
  seule: {
    aide: "Généré depuis l'audit du {date} - personas, territoires et carrefours d'audience. Aucun événement inventé : récurrences culturelles publiques croisées avec vos signaux. Dates TBC à re-vérifier à J-60.",
    depuis: "généré depuis l'audit du {date}",
    aideGenerer: 'Génère le calendrier éditorial de la marque',
    generation: 'Génération…',
    regenerer: 'Régénérer',
    generer: 'Générer le calendrier',
    recommande: 'recommandé après chaque audit / trimestre',
  },
  plusieurs: {
    aide: "Généré depuis l'audit du {date} - personas, territoires et carrefours d'audience de la marque. Dates TBC à re-vérifier à J-60.",
    evenements: '{n} événement | {n} événement | {n} événements',
    genere: '· généré le {date}',
    depuis: "depuis l'audit du {date}",
    pasEncore: "pas encore de calendrier : il se génère à l'audit de la marque",
    aideGenerer: 'Génère le calendrier éditorial de {marque}, sur ses personas et ses territoires',
    generer: 'Générer',
  },
  vide: {
    aucunDossier: 'Aucun dossier ouvert',
    aucunDossierTexte: "Le calendrier est celui d'un dossier : il rassemble les calendriers de toutes ses marques. Choisissez un dossier dans la barre de gauche.",
    chargement: 'Chargement du calendrier…',
    aucuneMarque: 'Aucune marque dans ce dossier',
    aucuneMarqueTexte: 'Le calendrier rassemble ceux des marques du dossier : créez-en une, son premier audit générera le sien.',
    croisement: 'Croisement personas × territoires × culture - ~30 s…',
    aucunCalendrierDossier: 'Aucun calendrier pour ce dossier',
    aucunCalendrierMarque: 'Aucun calendrier pour cette marque',
    croise: "Le calendrier croise vos personas, le territoire détecté et les carrefours d'audience avec les récurrences culturelles des 12 prochains mois.",
    chaqueMarque: 'Chaque marque reçoit le sien à son audit ; ils se rassemblent ici.',
    lancez: "Lancez d'abord un audit complet, puis générez.",
  },
  vue: {
    master: 'Master',
    grille: 'Grille',
  },
  filtre: {
    marque: 'Marque :',
    mois: 'Mois :',
    reco: 'Reco :',
    audience: 'Audience :',
    territoire: 'Territoire :',
    toutes: 'Toutes',
    tous: 'Tous',
    priorite: 'Priorité',
    considerer: 'À considérer',
    radar: 'Radar',
    coeur: 'Cœur',
    adjacent: 'Adjacent',
    horsCible: 'Hors cible',
  },
  selectionnes: 'sélectionnés en session',
  colonne: {
    mois: 'Mois',
    date: 'Date / fenêtre',
    evenement: 'Événement',
    categorie: 'Catégorie',
    audience: 'Audience',
    pourquoi: 'Pourquoi ça compte',
    prediction: 'Prédiction média',
    opportunite: 'Opportunité',
    format: 'Format',
    territoire: 'Territoire',
    reco: 'Reco',
  },
  aideSelection: 'Sélectionner pour la session commune',
  legende: {
    lecture: '· Confirmé = date fixe · Fenêtre = période probable · TBC = bouge (re-check à J-60)',
  },
  grille: {
    moments: 'Moments clés',
    calme: 'rien de notable - mois calme.',
    fenetre: 'fenêtre · {nom} - {date}',
  },
}
